// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yaF7c","fullView":"styles_fullView__29dX1"};